/**
 * SPドロワーの開閉。もとは sekka-header.liquid のインラインscriptだった。
 * 外部ファイルにしたのはキャッシュを効かせるため（インラインは毎ページHTMLに乗る）。
 *
 * 要素を初回に掴んで覚える書き方はしない。テーマエディタでヘッダーの
 * セクションが再描画されると、掴んでいた要素ごと消えてリスナーが死ぬ。
 * document への委譲なら、要素が入れ替わっても動き続ける。
 *
 * カテゴリー／モチーフの折りたたみはJSで制御しない。
 * 以前は高さを animate していたが端末によって引っかかった（クライアント指摘）。
 * details の開閉はブラウザに任せ、中身の動きはCSSだけ（sekka.css の sk-dw-in）。
 */
(function () {
  function drawer() {
    return document.querySelector('[data-sk-drawer]');
  }

  function toggle(open) {
    var d = drawer();
    var overlay = document.querySelector('[data-sk-drawer-overlay]');
    if (!d || !overlay) return;
    d.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sk-drawer-open]')) {
      toggle(true);
      return;
    }
    if (e.target.closest('[data-sk-drawer-overlay]')) {
      toggle(false);
      return;
    }
    var d = e.target.closest('[data-sk-drawer]');
    if (!d) return;
    // ×で閉じる。リンクを踏んだときも閉じておく（同じページ内の遷移で開いたまま残るため）
    if (e.target.closest('[data-sk-drawer-close]') || e.target.closest('a')) toggle(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') toggle(false);
  });
})();
